import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import VerifyOtp from './pages/VerifyOtp';
import Dashboard from './pages/Dashboard';
import EditProfile from './pages/EditProfile';
import ProfileDetail from './pages/ProfileDetail';
import Interests from './pages/Interests';
import Shortlists from './pages/Shortlists';
import Wallet from './pages/Wallet';
import MyProfile from './pages/MyProfile';
import AboutUs from './pages/AboutUs';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import AdminLayout from './components/AdminLayout';
import useImageProtection from './hooks/useImageProtection';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminUserEdit from './pages/admin/AdminUserEdit';
import AdminWallets from './pages/admin/AdminWallets';
import AdminWalletDetail from './pages/admin/AdminWalletDetail';

function App() {
  useImageProtection();

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/edit-profile" element={<PrivateRoute><EditProfile /></PrivateRoute>} />
          <Route path="/my-profile" element={<PrivateRoute><MyProfile /></PrivateRoute>} />
          <Route path="/profile/:id" element={<PrivateRoute><ProfileDetail /></PrivateRoute>} />
          <Route path="/interests" element={<PrivateRoute><Interests /></PrivateRoute>} />
          <Route path="/shortlists" element={<PrivateRoute><Shortlists /></PrivateRoute>} />
          <Route path="/wallet" element={<PrivateRoute><Wallet /></PrivateRoute>} />
          <Route path="/about" element={<AboutUs />} />

          {/* Admin routes */}
          <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="users/:id/edit" element={<AdminUserEdit />} />
            <Route path="wallets" element={<AdminWallets />} />
            <Route path="wallets/:userId" element={<AdminWalletDetail />} />
          </Route>

          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
